import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=2dbd1619&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2dbd1619', component.options)
    } else {
      api.reload('2dbd1619', component.options)
    }
    module.hot.accept("./VerifyCode.vue?vue&type=template&id=2dbd1619&", function () {
      api.rerender('2dbd1619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/verify/components/Verify/VerifyCode.vue"
export default component.exports